import {
  toEntityActivityFeed,
  isKnownEntityToolType,
  toEntityCards,
  toEntitySummary
} from "./entity-tool-adapters";
import type {
  EntityActivityFeedViewModel,
  EntityCardViewModel,
  EntitySummaryViewModel
} from "./types/entity-view";

export interface EntityRenderPayload {
  cards: EntityCardViewModel[];
  summary: EntitySummaryViewModel | null;
  activityFeed: EntityActivityFeedViewModel | null;
}

export function resolveEntityRenderPayload(
  toolType: string | undefined,
  output: unknown
): EntityRenderPayload {
  return {
    cards: toEntityCards(output, toolType),
    summary: toEntitySummary(output, toolType),
    activityFeed: toEntityActivityFeed(output, toolType)
  };
}

export function shouldUseEntityRenderer(
  toolType: string | undefined,
  output: unknown,
  errorText: unknown
): boolean {
  if (errorText || !output) {
    return false;
  }

  if (!isKnownEntityToolType(toolType)) {
    return false;
  }

  const payload = resolveEntityRenderPayload(toolType, output);
  return payload.cards.length > 0 || Boolean(payload.summary) || Boolean(payload.activityFeed);
}
